// Utilitário puro (zero imports de API/axios) pra combinar fragmentos de
// dadosRequerimentoConfig. Fica separado de dadosRequerimentoService.js de
// propósito: os config.js dos pedidos importam essa função, e config.js
// precisa continuar sendo dado puro (a suíte de testes importa todo o barrel
// de configs sem mockar nada — puxar a cadeia de serviços/axios pra dentro
// dele quebra o parse do Jest).
export const mergeDadosRequerimentoConfig = (...partes) => ({
  campos: partes.flatMap((p) => p?.campos || []),
  enderecos: partes.flatMap((p) => p?.enderecos || []),
  municipiosPorNome: partes.flatMap((p) => p?.municipiosPorNome || [])
});
